import {Feature} from 'acng/core/model/feature.js';

const name = 'rating';
export default name;
export const ratingFeature = new Feature(name);
